import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";

const PartnersBar = () => (
  <div className="bg-slate-100 border-t border-slate-200 py-6 overflow-hidden max-w-full">
    <div className="max-w-7xl mx-auto px-4">
      <p className="text-center text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">Featured Partners</p>
    </div>
    <div className="relative overflow-hidden">
      <div className="flex items-center gap-12 animate-scroll whitespace-nowrap">
        {[...Array(3)].map((_, setIdx) => (
          <div key={setIdx} className="flex items-center gap-12 shrink-0">
            <Link to="/learn" className="flex items-center gap-3 shrink-0 opacity-70 hover:opacity-100 transition-opacity">
              <img src="https://customer-assets.emergentagent.com/job_13e4391a-3898-46d5-8331-1b28fb5b216e/artifacts/j57nlcjh_IMG_0918.png" alt="NJFAN" className="h-12 w-12 rounded-full bg-white p-1 shadow object-contain" />
              <span className="text-sm font-semibold text-slate-600">National Jobs for All Network</span>
            </Link>
            <Link to="/learn" className="flex items-center gap-3 shrink-0 opacity-70 hover:opacity-100 transition-opacity">
              <img src="https://customer-assets.emergentagent.com/job_13e4391a-3898-46d5-8331-1b28fb5b216e/artifacts/r0j0b4dq_IMG_0919.jpeg" alt="Team4Success" className="h-12 w-12 rounded-full bg-white p-1 shadow object-contain" />
              <span className="text-sm font-semibold text-slate-600">Team4Success</span>
            </Link>
            <Link to="/learn" className="flex items-center gap-3 shrink-0 opacity-70 hover:opacity-100 transition-opacity">
              <div className="h-12 w-12 rounded-full bg-white p-1 shadow flex items-center justify-center" style={{color: '#226904'}}>
                <TrendingUp className="w-7 h-7" />
              </div>
              <span className="text-sm font-semibold text-slate-600">ProGeny Place</span>
            </Link>
            <Link to="/learn" className="flex items-center gap-3 shrink-0 opacity-80 hover:opacity-100 transition-opacity" data-testid="partner-harris-hf">
              <img src="https://customer-assets.emergentagent.com/job_3c7651d4-95a8-4bf7-8470-ffbaa9724e52/artifacts/jjq76int_IMG_0970.png" alt="Harris Homeownership Foundation" className="h-12 w-12 rounded-lg bg-slate-900 p-1 shadow object-contain" />
              <span className="text-sm font-semibold text-slate-600">Harris Homeownership Foundation</span>
            </Link>
            <Link to="/unions/union_memphis_clc" className="flex items-center gap-3 shrink-0 opacity-80 hover:opacity-100 transition-opacity" data-testid="partner-xcelente">
              <img src="https://customer-assets.emergentagent.com/job_3c7651d4-95a8-4bf7-8470-ffbaa9724e52/artifacts/89t6qmse_IMG_0973.jpeg" alt="Xcelente Trucking & Logistics" className="h-12 w-12 rounded-full bg-white shadow object-contain" />
              <span className="text-sm font-semibold text-slate-600">Xcelente Trucking &amp; Logistics</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
    <style>{`
      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-33.33%); }
      }
      .animate-scroll {
        animation: scroll 20s linear infinite;
      }
      .animate-scroll:hover {
        animation-play-state: paused;
      }
    `}</style>
  </div>
);

export default PartnersBar;
export { PartnersBar };
